
import React, { useContext } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import Auth from "../../../auth/Auth";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../App";
import { toast } from "react-toastify";
import { useAuth } from "../../../auth/AuthProvider";

const TopNav = () => {
  const navigate = useNavigate();
  const { setSpinner } = useContext(GlobalContext);
  const {setToken} = useAuth()
  const imageUrl = "./assets/images/";
  const handleLogout = () => {
    setSpinner(true);
    setTimeout(() => {
      Auth.logout();
      setToken(null)
      navigate('/login');
      toast.success("Log Out Succefully")
      setSpinner(false);
    }, 1000);
  };
  return (
    <>
      <Menu as="div" className="relative  block text-left">
        <div>
          <MenuButton className=" flex gap-3 items-center  w-full justify-center">
            <img src={imageUrl + "user.png"} alt="" />
            <ChevronDownIcon aria-hidden="true" className="-mr-1 h-6 w-6 " />
          </MenuButton>
        </div>

        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          <div className="py-1">
            <MenuItem>
              <button onClick={handleLogout}
                className="dropdown-item block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900">
                Log Out
              </button>
            </MenuItem>

          </div>
        </MenuItems>
      </Menu>
    </>
  );
};

export default TopNav;
